module.exports = __webpack_public_path__ + "img/1-search.3447446b.png";